import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const MainFooter: React.FC = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if (window.pageYOffset > 100) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            {/* standard footer */}
            <footer className="adminuiux-footer has-adminuiux-sidebar mt-auto">
                <div className="container-fluid">
                    <div className="row gx-3 gx-lg-4">
                        <div className="col-12 col-md col-lg py-2">
                            <span className="small">Copyright &copy;2025, Designed by <a href="https://adminuiux.com" target="_blank" className="" rel="noreferrer">Adminuiux</a> ❤️ </span>
                        </div>
                        <div className="col-12 col-md-auto col-lg-auto align-self-center">
                            <ul className="nav small">
                                <li className="nav-item"><Link className="nav-link" to="/app/company-help-center">Help</Link></li>
                                <li className="nav-item opacity-50">|</li>
                                <li className="nav-item"><Link className="nav-link" to="/app/terms-of-use">Terms of Use</Link></li>
                                <li className="nav-item opacity-50">|</li>
                                <li className="nav-item"><Link className="nav-link" to="/app/privacy-policy">Privacy Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>

            {/* theming action*/}
            <div className="position-fixed bottom-0 end-0 m-3 z-index-5 fixedbuttons" id="fixedbuttons">
                <button className="btn btn-square btn-theme shadow rounded-circle" type="button" data-bs-toggle="offcanvas" data-bs-target="#theming" aria-controls="theming"><i className="bi bi-palette"></i></button>
                <br />
                {showScrollTop && (
                    <button onClick={scrollToTop} className="btn btn-theme btn-square shadow mt-2 rounded-circle theme-black"><i className="bi bi-arrow-up"></i></button>
                )}
            </div>


        </>
    );
};

export default MainFooter;
